import axios from "axios";
import React, { useState, useEffect } from "react";
import { Country, State, City } from "country-state-city";
import { Formik, Field, Form, ErrorMessage, useFormikContext } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Select from "react-select"; // Import react-select
// import ReactGA from "react-ga4";

// Define the validation schema
const ModalSchema = Yup.object().shape({
  fullName: Yup.string().required("Please enter your full name"),
  contactNumber: Yup.string()
    .matches(/^[0-9]+$/, "Must be a number")
    .max(10, "Number should be of 10 digits")
    .min(10, "Number should be of 10 digits")
    .required("Please enter contact number"),
  email: Yup.string().email("Invalid email"),
  location: Yup.string().required("Please select your clinic location"),
  revenue: Yup.string().required("Please select your current monthly revenue"),
  target: Yup.string().required("Please select your target monthly goal"),
  marketingBudget: Yup.string().required("Please select your marketing budget"),
  appointments: Yup.string().required(
    "Please specify the number of appointments"
  ),
  // connectTime: Yup.date().required("Please select a connection time"),
  // ticket: Yup.string().required("Please select your average ticket size")
});

const ScrollToFieldError = () => {
  const { submitCount, isValid, errors, isSubmitting } = useFormikContext();

  useEffect(() => {
    if (submitCount > 0 && !isValid) {
      const fieldErrorNames = Object.keys(errors);
      if (fieldErrorNames.length > 0) {
        const fieldName = fieldErrorNames[0];
        const element = document.querySelector(`[name="${fieldName}"], [id="${fieldName}"]`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          (element as HTMLElement).focus?.();
        }
      }
    }
  }, [submitCount, isSubmitting, isValid, errors]);

  return null;
};

function Modal({ isOpen, onClose }: any) {
  const [states, setStates] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const currentDateTime = new Date().toISOString().slice(0, 16);

  useEffect(() => {
    const countryList = Country.getAllCountries();
    const defaultCountry = countryList.find(
      (country) => country.isoCode === "IN"
    );
    if (defaultCountry) {
      const stateList = State.getStatesOfCountry(defaultCountry.isoCode);
      setStates(stateList);
    }
  }, []);

  // const handleSubmit = async (values: any) => {
  //   console.log(values); // Debugging

  //   const payload = values;
  //   payload.submissionTime = new Date().toLocaleString();
  //   setLoadingSubmit(true);
  //   try {
  //     const response = await axios.post(
  //       process.env.REACT_APP_N8N_URL || "",
  //       values
  //     );

  //     await response;

  //     console.log("Response from n8n:", response.data);
  //     if (response.data != null)
  //       toast.success(
  //         "Thank you for your interest! We will get in touch soon."
  //       );

  //     onClose();
  //   } catch (error) {
  //     console.error("Submission error:", error);
  //     toast.error("Failed to save data. Please try again.");
  //   } finally {
  //     setLoadingSubmit(false);
  //   }
  // };

  const encodeToXmlEntities = (str: string) => {
    return str.replace(/[^a-zA-Z0-9]/g, (char) => `&#${char.charCodeAt(0)};`);
  };

  const handleSubmit = async (values: any) => {
    console.log(values);

    if (typeof window !== "undefined" && window.fbq) {
      values["submissionTime"]= new Date().toLocaleString();
      window.fbq("track", "ButtonClicked", { buttonName: "Submit" , data:values });
    } else {
      console.warn("Facebook Pixel not initialized");
    }
    console.log("Facebook Pixel Event Triggered!");



    setLoadingSubmit(true);

    // Prepare the lead data for Odoo CRM API
    const leadData = {
      params: {
        name: values.fullName,
        phone: values.contactNumber,
        opportunity: "B2B April 25 Campaign Patient Acquisition",
        salesperson_id: 17,
        company_id: 2,
        email_from: values.email || "",
        contact_name: values.fullName,
        city: values.location || "",
        description: `
          Owner: ${values.owner || "N/A"}
          Speciality: ${values.speciality || "N/A"}
          Website: ${values.websiteLink || "N/A"}
          State: ${
            states.find((s) => s.isoCode === values.state)?.name || "N/A"
          }
          City: ${values.location || "N/A"}
          Current Revenue: ${values.revenue || "N/A"}
          Target Revenue: ${values.target || "N/A"}
          Marketing Budget: ${values.marketingBudget || "N/A"}
          Appointments: ${values.appointments || "N/A"}
          Average Ticket Size: ${values.ticket || "N/A"}
          Preferred Connection Time: ${values.connectTime || "N/A"}
          Submission Time: ${new Date().toLocaleString()}
        `.trim(),
      },
    };

    try {
      console.log("Sending leadData:", JSON.stringify(leadData, null, 2));

      const createLeadResponse = await axios.post(
        "https://mysamplewebsite.in/api/crm_leads/create",
        leadData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Lead creation response:", createLeadResponse.data);

      if (createLeadResponse.data.status !== "success") {
        throw new Error(
          createLeadResponse.data.message || "Failed to create lead"
        );
      }

      toast.success("Thank you for your interest! We will get in touch soon.");
      onClose();
    } catch (error: any) {
      console.error("Submission error:", error);
      toast.error(
        error.response?.data?.message || 
        error.message || 
        "Failed to save data. Please try again."
      );
    } finally {
      setLoadingSubmit(false);
    }
  };

  // const handleSubmit = async (values: any) => {
  //   console.log(values);

  //   const leadData = {
  //     name: values.fullName,
  //     phone: values.contactNumber,
  //     email_from: values.email,
  //     street: values.location,
  //     description: `Speciality: ${values.speciality}\nWebsite: ${values.websiteLink}\nCurrent Revenue: ${values.revenue}\nTarget Revenue: ${values.target}\nMarketing Budget: ${values.marketingBudget}\nAppointments: ${values.appointments}\nAverage Ticket Size: ${values.ticket}\nPreferred Connection Time: ${values.connectTime}`,
  //   };

  //   setLoadingSubmit(true);

  //   try {
  //     // Use a proxy endpoint (e.g., /api) to avoid CORS issues
  //     const loginResponse = await axios.post('/api/web/session/authenticate', {
  //       jsonrpc: "2.0",
  //       params: {
  //         db: "adgencycrm",
  //         login: "tuhin@adgencymedia.com",
  //         password: "Sharky@1000",
  //       },
  //     });

  //     const sessionId = loginResponse.headers["set-cookie"];

  //     const createLeadResponse = await axios.post(
  //       '/api/web/dataset/call_kw',
  //       {
  //         jsonrpc: "2.0",
  //         method: "call",
  //         params: {
  //           model: "crm.lead",
  //           method: "create",
  //           args: [leadData],
  //           kwargs: {},
  //         },
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Cookie: sessionId,
  //         },
  //       }
  //     );

  //     console.log("Lead created in Odoo:", createLeadResponse.data);
  //     toast.success("Thank you for your interest! We will get in touch soon.");
  //     onClose();
  //   } catch (error) {
  //     console.error("Submission error:", error);
  //     toast.error("Failed to save data. Please try again.");
  //   } finally {
  //     setLoadingSubmit(false);
  //   }
  // };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 p-4">
      <div className="bg-white p-6 rounded-md shadow-lg relative w-full sm:max-w-md md:max-w-lg lg:max-w-2xl xl:max-w-3xl max-h-[85vh] overflow-y-auto sm:p-8">
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl"
          onClick={onClose}
        >
          &times;
        </button>
        <h2 className="text-xl font-bold mb-4 text-center text-red-600">
          Enter Your Details
        </h2>
        <Formik
          initialValues={{
            fullName: "",
            contactNumber: "",
            email: "",
            owner: "",
            speciality: "",
            websiteLink: "",
            location: "",
            revenue: "",
            target: "",
            marketingBudget: "",
            appointments: "",
            connectTime: "",
            ticket: "",
            state: "",
          }}
          validationSchema={ModalSchema}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, values, handleChange }) => (
            <Form className="space-y-6">
              <ScrollToFieldError />
              {/* Full Name (Required) */}
              <label className="text-left block">
                Full Name <span className="text-red-500">*</span>
                <Field
                  type="text"
                  name="fullName"
                  placeholder="Full Name"
                  className="border p-3 w-full rounded-md focus:outline-none focus:ring-2 focus:ring-[#4F9443]"
                />
                <ErrorMessage
                  name="fullName"
                  component="div"
                  className="text-red-600 text-sm"
                />
              </label>

              {/* Mobile Number (Required) */}
              <label className="text-left block">
                Contact Number <span className="text-red-500">*</span>
                <Field
                  type="text"
                  name="contactNumber"
                  placeholder="Contact Number"
                  className="border p-3 w-full rounded-md focus:outline-none focus:ring-2 focus:ring-[#4F9443]"
                />
                <ErrorMessage
                  name="contactNumber"
                  component="div"
                  className="text-red-600 text-sm"
                />
              </label>

              {/* Email (Optional) */}
              <label className="text-left block">
                Email Address
                <Field
                  type="text"
                  name="email"
                  placeholder="Email Address"
                  className="border p-3 w-full rounded-md focus:outline-none focus:ring-2 focus:ring-[#4F9443]"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-red-600 text-sm"
                />
              </label>

              {/* Owner (Optional) */}
              <label className="text-left block">
                Are you the owner?
                <Field
                  type="text"
                  name="owner"
                  placeholder="Yes/No"
                  className="border p-3 w-full rounded-md focus:outline-none focus:ring-2 focus:ring-[#4F9443]"
                />
                <ErrorMessage
                  name="owner"
                  component="div"
                  className="text-red-600 text-sm"
                />
              </label>

              {/* Speciality (Optional) */}
              <label className="text-left block">
                What is your speciality?
                <Field
                  type="text"
                  name="speciality"
                  placeholder="Speciality"
                  className="border p-3 w-full rounded-md focus:outline-none focus:ring-2 focus:ring-[#4F9443]"
                />
                <ErrorMessage
                  name="speciality"
                  component="div"
                  className="text-red-600 text-sm"
                />
              </label>

              {/* Website Link (Optional) */}
              <label className="text-left block">
                Website Link
                <Field
                  type="text"
                  name="websiteLink"
                  placeholder="Website Link"
                  className="border p-3 w-full rounded-md focus:outline-none focus:ring-2 focus:ring-[#4F9443]"
                />
                <ErrorMessage
                  name="websiteLink"
                  component="div"
                  className="text-red-600 text-sm"
                />
              </label>

              <label className="text-left block">
                Where is your clinic located?{" "}
                <span className="text-red-500">*</span>
                <Select
                  options={states.map((state) => ({
                    label: state.name,
                    value: state.isoCode,
                  }))}
                  value={
                    values.state
                      ? {
                          label: states.find((s) => s.isoCode === values.state)
                            ?.name,
                          value: values.state,
                        }
                      : null
                  }
                  onChange={(selectedOption: any) => {
                    setFieldValue("state", selectedOption.value);
                    setFieldValue("location", "");
                    const cityList = City.getCitiesOfState(
                      "IN",
                      selectedOption.value
                    );
                    setCities(cityList);
                  }}
                  placeholder="Select State..."
                  isSearchable
                  className="mb-2"
                />
              </label>

              {/* City Dropdown with Search */}
              <label className="text-left block" id="location">
                <Select
                  options={cities.map((city) => ({
                    label: city.name,
                    value: city.name,
                  }))}
                  value={
                    values.location
                      ? { label: values.location, value: values.location }
                      : null
                  }
                  onChange={(selectedOption: any) => {
                    setFieldValue("location", selectedOption.value); // Update Formik state
                  }}
                  placeholder="Select City..."
                  isSearchable
                  isDisabled={!values.state} // Disable until a state is selected
                />
                <ErrorMessage
                  name="location"
                  component="div"
                  className="text-red-600 text-sm"
                />
              </label>

              {/* Revenue (Required) */}
              <label className="text-left block">
                What is your current monthly revenue?{" "}
                <span className="text-red-500">*</span>
                <div className="flex flex-col">
                  {[
                    "Rs.0 - 1.5 Lacs",
                    "Rs.2 Lacs  - 5 Lacs ",
                    "Rs.5 Lacs  - 10 Lacs ",
                    "Rs.10 Lacs - 30 Lacs",
                    "Rs.30 Lacs - 1 Cr",
                    "Rs.1Cr Above",
                  ].map((range) => (
                    <label key={range} className="flex items-center">
                      <Field
                        type="radio"
                        name="revenue"
                        value={range}
                        className="mr-2"
                      />
                      {range}
                    </label>
                  ))}
                </div>
                <ErrorMessage
                  name="revenue"
                  component="div"
                  className="text-red-600"
                />
              </label>

              {/* Target (Required) */}
              <label className="text-left block">
                What is your target monthly goal working with us?{" "}
                <span className="text-red-500">*</span>
                <div className="flex flex-col">
                  {[
                    "Rs.2 Lacs  - 5 Lacs ",
                    "Rs.5 Lacs  - 10 Lacs ",
                    "Rs.10 Lacs - 30 Lacs",
                    "Rs.30 Lacs - 1 Cr",
                    "Rs.1Cr Above",
                  ].map((range) => (
                    <label key={range} className="flex items-center">
                      <Field
                        type="radio"
                        name="target"
                        value={range}
                        className="mr-2"
                      />
                      {range}
                    </label>
                  ))}
                </div>
                <ErrorMessage
                  name="target"
                  component="div"
                  className="text-red-600"
                />
              </label>

              {/* Marketing Budget (Required) */}
              <label className="text-left block">
                How much are you looking to invest in advertisements for
                acquiring new customers? <span className="text-red-500">*</span>
                <div className="flex flex-col">
                  {[
                    "Rs.0 - 50,000 (Hey you need to allocate at least ₹80K - 1 Lac budget & we will show you our wonders, guaranteed)",
                    "Rs.50K - 1 Lac",
                    "Rs.1Lac - 1.5 Lacs",
                    "Rs.1.5Lacs - 2 Lacs",
                    "Rs.2 Lacs  - 5 Lacs ",
                    "Rs.5 Lacs  - 10 Lacs ",
                    "Rs.10 Lacs - 30 Lacs",
                    "Rs.30 Lacs - 1 Cr",
                    "Rs.1Cr Above",
                  ].map((range) => (
                    <label key={range} className="flex items-center">
                      <Field
                        type="radio"
                        name="marketingBudget"
                        value={range}
                        className="mr-2"
                      />
                      <span
                        className={
                          range ===
                          "Rs.0 - 50,000 (Hey you need to allocate at least ₹80K - 1 Lac budget & we will show you our wonders, guaranteed)"
                            ? "text-red-600"
                            : ""
                        }
                      >
                        {range}
                      </span>
                    </label>
                  ))}
                </div>
                <ErrorMessage
                  name="marketingBudget"
                  component="div"
                  className="text-red-600 text-sm"
                />
              </label>

              {/* Number of Appointments (Required) */}
              <label className="text-left block">
                How many appointments can your clinic handle in a month?{" "}
                <span className="text-red-500">*</span>
                {["30 - 40", "40 - 50", "60 - 70", "70 above"].map((range) => (
                  <label key={range} className="flex items-center">
                    <Field
                      type="radio"
                      name="appointments"
                      value={range}
                      className="mr-2"
                    />
                    {range}
                  </label>
                ))}
                <ErrorMessage
                  name="appointments"
                  component="div"
                  className="text-red-600 text-sm"
                />
              </label>

              {/* Average of Ticket size (Required) */}
              <label className="text-left block">
                What is your average ticket size?{" "}
                <span className="text-red-500">*</span>
                {[
                  "Rs.0 - 3000 (Please do not contact us we cannot help you)",
                  "Rs.3000 - 10,000",
                  "Rs.10,000 - 20,000",
                  "Rs.20,000 - 40,000",
                  "Rs.40,000 and above",
                ].map((range) => (
                  <label key={range} className="flex items-center">
                    <Field
                      type="radio"
                      name="ticket"
                      value={range}
                      className="mr-2"
                    />
                    <span
                      className={
                        range ===
                        "Rs.0 - 3000 (Please do not contact us we cannot help you)"
                          ? "text-red-600"
                          : ""
                      }
                    >
                      {range}
                    </span>
                  </label>
                ))}
                <ErrorMessage
                  name="ticket"
                  component="div"
                  className="text-red-600 text-sm"
                />
              </label>

              <div className="text-lg font-bold">
                <span className="text-black">
                  Business seeking profit sharing model please do not contact us
                </span>
              </div>

              <label className="text-left block">
                When would you like to connect?{" "}
                <span className="text-red-500">*</span>
                <Field
                  type="datetime-local"
                  min={currentDateTime}
                  name="connectTime"
                  className="border p-2 w-full rounded-md"
                />
                <ErrorMessage
                  name="connectTime"
                  component="div"
                  className="text-red-600"
                />
              </label>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={loadingSubmit}
                className={`w-full bg-red-600 text-white py-3 px-4 rounded-md mt-4 ${loadingSubmit}`}
              >
                {loadingSubmit ? "Submitting..." : "Submit"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default Modal;
